<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <ubraniaMenu></ubraniaMenu>
        <div class="widget-heading">
          <div class="row mb-3">
            <div class="col-12 d-flex flex-wrap gap-2">
              <div class="flex-fill d-flex" style="min-width: 300px;">
                <select v-model="selectedTyp" class="form-select w-100" @change="loadTyp">
                  <option v-for="typ in typy" :key="typ.id" :value="typ.id">{{ typ.nazwa }}</option>
                </select>
              </div>

              <div class="flex-fill d-flex" style="min-width: 300px;">
                <select v-model="selectedGrupa" class="form-select w-100" @change="loadGrupa">
                  <option value="">-- Wybierz grupę --</option>
                  <option v-for="grupa in grupyLocal" :key="grupa.id" :value="grupa.id">{{ grupa.nazwa }}</option>
                </select>
              </div>
            </div>
          </div>

        </div>
        <div class="widget-content">
          <div v-if="artykulyFiltered.length">
            <div class="row">
              <div v-for="artykul in artykulyFiltered" :key="artykul.id" class="col-md-3 mb-4">
                <div class="card h-100 shadow-sm p-3">
                  <h5>{{ artykul.nazwa }} <span v-if="artykul.opis">({{ artykul.opis }})</span></h5>
                  <div class="table-responsive">
                    <table class="table table-bordered table-hover text-center">
                      <thead>
                    <tr>
                      <th class="bg-gray-100 text-start">Rozmiar</th>
                      <th class="bg-gray-100 text-start">Ilość</th>
                    </tr>
                      </thead>
                      <tbody>
                    <tr v-for="set in artykul.rozmiary_set" :key="set.id">
                      <td class="text-start">{{ set.nazwa }}</td>
                      <td class="text-start">
                        <input type="number" class="form-control form-control-sm" v-model.number="set.ile"
                               @change="updateIle(artykul.id, set)">
                      </td>
                    </tr>
                      </tbody>
                    </table>
                  </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import ubraniaMenu from "@/Pages/BHP/parts/ubraniaMenu.vue";
import axios from 'axios';

export default {
  components: {AppLayout, ubraniaMenu},
  props: {
    grupy: Array,
    artykuly: Array,
    rozmiary: Array,
    typy: Array,
    typ: Number,
  },
  data() {
    return {
      selectedGrupa: 1,
      selectedTyp: this.typ ?? 1,
      artykulyFiltered: [],
      grupyLocal: [...this.grupy],
    };
  },
  mounted() {
    // po załadowaniu komponentu od razu ładujemy artykuły dla grupy 1
    this.loadGrupa();
  },
  methods: {
    loadTyp() {
      axios.get(route('bhp.stan.odziezy.grupa', {typ: this.selectedTyp}))
          .then(res => {
            this.grupyLocal = res.data.grupy;
            this.selectedGrupa = this.grupyLocal.length ? this.grupyLocal [0].id : null;
            if (this.selectedGrupa) {
              this.loadGrupa();
            } else {
              this.artykulyFiltered = [];
            }
          })
          .catch(err => {
            console.error(err);
          });
    },

    loadGrupa() {
      if (!this.selectedGrupa) {
        this.artykulyFiltered = [];
        return;
      }

      axios.get(route('bhp.stan.odziezy.grupa', {
        grupa: this.selectedGrupa,
        typ: this.selectedTyp
      }))
          .then(res => {
            this.artykulyFiltered = res.data.map(art => {
              const rozmiarySet = art.rozmiary_set?.map(r => ({
                id: r.id,
                nazwa: r.rozmiar?.nazwa || r.nazwa,
                ile: r.ile || 0
              })) || [];

              return {...art, rozmiary_set: rozmiarySet};
            });
          })
          .catch(err => {
            console.error(err);
          });
    },
    updateIle(artykulId, set) {
      axios.put(route('bhp.setRozmiary.updateIle', {id: set.id}), {ile: set.ile})
          .then(res => {
            this.showToast('success', 'Zapisano', 'Zaktualizowano ilość dla wybranego rozmiaru.');
            console.log('Zaktualizowano ilość:', res.data);
          })
          .catch(err => {
            this.showToast('error', 'Błąd', 'Nie udało się zaktualizować ilości dla wybranego rozmiaru.');
            console.error(err);
          });
    },
    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }

  },
};
</script>

<style scoped>
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
.text-start {
  text-align: left;
}
table th, table td {
  min-width: 50px;
  height: 32px;
}
</style>
